export const formatFileSize = (bytes?: number): string => {
  if (!bytes) return '-';

  const kb = bytes / 1024;
  const mb = kb / 1024;

  if (mb >= 1) {
    return `${mb.toFixed(1)} MB`;
  }

  return `${kb.toFixed(1)} KB`;
};

export const formatDurationFromSeconds = (totalSeconds: string | number): string => {
  const seconds =
    typeof totalSeconds === 'string' ? parseFloat(totalSeconds) : totalSeconds;
  if (Number.isNaN(seconds) || seconds < 0) return '-';
  if (seconds < 60) return '< 1m';

  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  const parts: string[] = [];
  if (days > 0) parts.push(`${days}d`);
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0) parts.push(`${minutes}m`);

  return parts.join(' ');
};

/**
 * Format a duration in seconds as "1h 18m 33s" / "18m 33s" / "33s".
 * Use for run-record durations that need second-level precision.
 */
export function formatRunDuration(
  totalSeconds: number | null | undefined,
): string | null {
  if (
    totalSeconds === null ||
    totalSeconds === undefined ||
    !Number.isFinite(totalSeconds)
  ) {
    return null;
  }
  if (totalSeconds <= 0) return '0s';
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);
  const parts: string[] = [];
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0) parts.push(`${minutes}m`);
  if (seconds > 0 || parts.length === 0) parts.push(`${seconds}s`);
  return parts.join(' ');
}

export function isKnownUser(value: string | null | undefined): value is string {
  return Boolean(value) && value!.toLowerCase() !== 'unknown';
}

export const REPORT_STATUS_READY = 'Ready';
